import React, { useState, useEffect } from 'react';
import globalIP from '../../GlobelIP';
import {
  Input,
  InputGroup,
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Checkbox,
  FlexboxGrid,
  Col,
  CheckPicker,
  Notification,
  Loader,
  Drawer,
  Modal,
  Row,
  Grid,
  ButtonGroup,
  IconButton,
  Whisper,
  Tooltip,
  Table,
  SelectPicker
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import { Link, useNavigate } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import MenuIcon from '@rsuite/icons/Menu';
import { useInView } from 'react-intersection-observer';
import ugr from '@/UGRoute';
import useLabel from '@/clientWeb/hook/Label';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import NavD from './NavD';
import Library from './Library';
import useFilter from '../tables/members/Filters';
import FilterDrawer from '@/components/FilterDrawer';
import HeaderFilter from '@/components/HeaderFilter';
import ProductQuickView from '@/components/ProductSearchPage/ProductQuickView';
import { Dropdown } from 'antd';
import { EyeFilled } from '@ant-design/icons';
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const { Column, HeaderCell, Cell } = Table;

const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div style={{ lineHeight: '46px' }}>
      <Checkbox
        value={rowData[dataKey]}
        inline
        onChange={onChange}
        checked={checkedKeys.some(item => item === rowData[dataKey])}
      />
    </div>
  </Cell>
);

const ManageCollection = () => {
  const ipp = globalIP;
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [data123, setData123] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [selectedItems, setSelectedItems] = useState([]);
  const { attributesName } = useLabel();
  const [selectedImagePath, setSelectedImagePath] = useState('');

  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItems(prevSelectedItems => [...prevSelectedItems, value]);
    } else {
      setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
    }
  };
  const handleCartClose = () => {
    setIsCartOpen(false);
  };
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ipp}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [openSet, setOpenSet] = useState(false);
  // const [searchQuery, setSearchQuery] = useState('');
  const handleSearch = value => {
    setSearchQuery(value);
  };
  const [showPanel, setShowPanel] = useState(true);
  const [matname, setMatName] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const handlePanelToggle = mtname => {
    setShowSearch(true);
    setMatName(mtname);
    setShowPanel(!showPanel);
  };
  const [limit, setLimit] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [isLoadmdata, setIsLoadmdata] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const handleDatechange = value => {
    setCurrentPage(1)
    setData123([]);
    setSelectedDateRange(value);
  };
  const handleUpdatedDatechange = value => {
    setCurrentPage(1)
    setData123([]);
    setSelectedUpdatedDateRange(value);
  };
  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });
  const [filtersApplied, setFiltersApplied] = useState(false);
  const handleCheckAll = (value, checked) => {
    if (filtersApplied) {
      const filteredProducts = applyFilters();
      setSelectedItems(checked ? filteredProducts.map(item => item.id) : []);
    } else {
      setSelectedItems(checked ? data123.map(item => item.id) : []);
    }
  };
  const applyFilters = () => {
    let filteredProducts = data123;

    if (selectedCategory.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedCategory.includes(item.attributes.CategoryCode)
      );
    }

    if (selectedProductType.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedProductType.includes(item.attributes.ProductTypeCode)
      );
    }

    if (selectedColor.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedColor.includes(item.attributes.ColorCode)
      );
    }

    if (selectedFinish.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedFinish.includes(item.attributes.FinishCode)
      );
    }

    if (selectedhsn.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedhsn.includes(item.attributes.HSNCode)
      );
    }

    if (selectedmaterial.length > 0) {
      filteredProducts = filteredProducts.filter(item => {
        const materialCode = item.attributes.ProductionDetail[0]?.MaterialCode || '';
        return selectedmaterial.includes(materialCode);
      });
    }

    return filteredProducts;
  };

  const [searchQuery, setSearchQuery] = useState('');
  const [clearSearchQuery, setClearSearchQuery] = useState(false);

  // useEffect for clearing searchQuery
  useEffect(() => {
    if (clearSearchQuery) {
      fetchDatar();
      //  TableFetchData();
    }
  }, [clearSearchQuery]);

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    //  setPage(1);
    fetchDatar(); // Your data fetching function
    //  TableFetchData();  // Another data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes

  useEffect(() => {
    if (matname) {
      fetchDatar();
      setCurrentPage(1);
    }
  }, [
    matname,
    selectedDateRange,
    selectedUpdatedDateRange,
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedmaterial,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku,
    currentPage
  ]);

  // useEffect for clearing searchQuery
  useEffect(() => {
    if (clearSearchQuery) {
      fetchData();
      // TableFetchData();
    }
  }, [clearSearchQuery]);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    // setPage(1);
    fetchDatar(); // Your data fetching function
    // TableFetchData();  // Another data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes
  const formatDateToISO = date => date.toISOString();

  const getFirstDayOfWeek = date => {
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfMonth = date => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfLastMonth = date => {
    const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    firstDayOfLastMonth.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDayOfLastMonth);
  };

  const getLastDayOfLastMonth = date => {
    const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    lastDayOfLastMonth.setHours(23, 59, 59, 999);
    return formatDateToISO(lastDayOfLastMonth);
  };

  const getDateDaysAgo = (date, days) => {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    result.setHours(0, 0, 0, 0);
    return formatDateToISO(result);
  };
  const fetchDatar = async () => {
    if (isLoadmdata) {
      return;
    }
    setIsLoadmdata(true);
    try {
      let categoryFilter = '';
      if (selectedCategory.length > 0) {
        const categoryFilterString = selectedCategory
          .map(cat => `filters[CategoryCode][$eq]=${cat}`)
          .join('&');
        categoryFilter = `&${categoryFilterString}`;
      }
      let protypeFilter = '';
      if (selectedProductType.length > 0) {
        const protypeFilterString = selectedProductType
          .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
          .join('&');
        protypeFilter = `&${protypeFilterString}`;
      }
      let colorFilter = '';
      if (selectedColor.length > 0) {
        const colorFilterString = selectedColor
          .map(color => `filters[ColorCode][$eq]=${color}`)
          .join('&');
        colorFilter = `&${colorFilterString}`;
      }
      let finishFilter = '';
      if (selectedFinish.length > 0) {
        const finishFilterString = selectedFinish
          .map(finish => `filters[FinishCode][$eq]=${finish}`)
          .join('&');
        finishFilter = `&${finishFilterString}`;
      }
      let hsnFilter = '';
      if (selectedhsn.length > 0) {
        const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
        hsnFilter = `&${hsnFilterString}`;
      }
      let matFilter = '';
      if (selectedmaterial.length > 0) {
        const matFilterString = selectedmaterial
          .map(mat => `filters[ProductionDetail][MaterialCode][$eq]=${mat}`)
          .join('&');
        matFilter = `&${matFilterString}`;
      }
      let buyerFilter = '';
      if (selectedBuyer.length > 0) {
        const buyerFilterString = selectedBuyer
          .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
          .join('&');
        buyerFilter = `&${buyerFilterString}`;
      }
      let searchFilter = '';
      if (selectedSearch.length > 0) {
        const SearchFilterString = selectedSearch
          .map(search => `filters[SearchKeyword][$eq]=${search}`)
          .join('&');
        searchFilter = `&${SearchFilterString}`;
      }
      let aliasFilter = '';
      if (selectedAlias.length > 0) {
        const aliasFilterString = selectedAlias
          .map(alias => `filters[ProductId][$eq]=${alias}`)
          .join('&');
        aliasFilter = `&${aliasFilterString}`;
      }
      let pronFilter = '';
      if (selectedpron.length > 0) {
        const pronFilterString = selectedpron
          .map(pron => `filters[ProductName][$eq]=${pron}`)
          .join('&');
        pronFilter = `&${pronFilterString}`;
      }
      let prodFilter = '';
      if (selectedpd.length > 0) {
        const prodFilterString = selectedpd
          .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
          .join('&');
        prodFilter = `&${prodFilterString}`;
      }
      let madeFilter = '';
      if (selectedmade.length > 0) {
        const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
        madeFilter = `&${madeFilterString}`;
      }
      let skuFilter = '';
      if (selectedsku.length > 0) {
        const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
        skuFilter = `&${skuFilterString}`;
      }
      let searchQryFilter = '';
      if (searchQuery.length > 0) {
        let searchQryy = searchQuery.trim();
        const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
        searchQryFilter = `&${searchQry}`;
        //  setCurrentPage(1)
      }
      let datefilter = '';
      let updateddatefilter = '';

      const today = new Date();
      const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
      const endOfToday = new Date(); // Current time

      switch (selectedDateRange) {
        case 'Today':
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(
            startOfToday
          )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;

        case 'Yesterday':
          const yesterday = new Date();
          yesterday.setDate(today.getDate() - 1);
          datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
          break;

        case 'This week':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'Last week':
          const lastWeekStart = new Date(today);
          lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(
            lastWeekStart
          )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'This month':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
          break;

        case 'Last month':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
            today
          )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
          break;

        case 'Last 3 month':
          const threeMonthsAgo = new Date(today);
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
          break;

        case 'Last 6 month':
          const sixMonthsAgo = new Date(today);
          sixMonthsAgo.setMonth(today.getMonth() - 6);
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
          break;

        default: // Or handle the default case as needed
          datefilter = '';
          break;
      }

      switch (selectedUpdatedDateRange) {
        case 'Today':
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
            startOfToday
          )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;

        case 'Yesterday':
          updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
          break;

        case 'This week':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'Last week':
          const lastWeekStart = new Date(today);
          lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
            lastWeekStart
          )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'This month':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
          break;

        case 'Last month':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
            today
          )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
          break;

        case 'Last 3 month':
          const threeMonthsAgo = new Date(today);
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
          break;

        case 'Last 6 month':
          const sixMonthsAgo = new Date(today);
          sixMonthsAgo.setMonth(today.getMonth() - 6);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
          break;

        default: // Or handle the default case as needed
          updateddatefilter = '';
          break;
      }


      const response = await fetch(
        `${globalIP}/api/products?populate=*&filters[MaterialCollection][MatCollectionCode][$eq]=${matname}&sort[0]=id:desc&pagination[page]=${currentPage}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${searchQryFilter}&${updateddatefilter}&${datefilter}`
      );
      const json = await response.json();
      setLimit(json.data.length);

      if (currentPage === 1) {
        setData123(json.data);
      } else {
        setData123(prevData => [...prevData, ...json.data]);
      }
      setMeta123(json.meta);
      setIsLoadmdata(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [collectiondata, setCollectiondata] = useState([]);
  const [productData, setProductData] = useState({});
  const [collectionfdata, setCollectionfdata] = useState([]);
  const [selectedColl, setSelectedColl] = useState([]);
  const [colLoading, setColLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, [selectedColl]);

  useEffect(() => {
    fetchDatan();
  }, []);
  const fetchDatan = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/mstmaterialcollections?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstmaterialcollections?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.MatCollectionName,
          value: item.attributes.MatCollectionCode
        }));
        allData.push(...processedData);
      }
      setCollectionfdata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData = async () => {
    if (colLoading) {
      return;
    }
    setColLoading(true);
    try {
      let collFilter = '';
      if (selectedColl.length > 0) {
        const collFilterString = selectedColl
          .map(cat => `filters[MatCollectionCode][$eq]=${cat}`)
          .join('&');
        collFilter = `&${collFilterString}`;
      }
      let categoryFilter = '';
      if (selectedCategory.length > 0) {
        const categoryFilterString = selectedCategory
          .map(cat => `filters[CategoryCode][$eq]=${cat}`)
          .join('&');
        categoryFilter = `&${categoryFilterString}`;
      }
      let protypeFilter = '';
      if (selectedProductType.length > 0) {
        const protypeFilterString = selectedProductType
          .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
          .join('&');
        protypeFilter = `&${protypeFilterString}`;
      }
      let colorFilter = '';
      if (selectedColor.length > 0) {
        const colorFilterString = selectedColor
          .map(color => `filters[ColorCode][$eq]=${color}`)
          .join('&');
        colorFilter = `&${colorFilterString}`;
      }
      let finishFilter = '';
      if (selectedFinish.length > 0) {
        const finishFilterString = selectedFinish
          .map(finish => `filters[FinishCode][$eq]=${finish}`)
          .join('&');
        finishFilter = `&${finishFilterString}`;
      }
      let hsnFilter = '';
      if (selectedhsn.length > 0) {
        const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
        hsnFilter = `&${hsnFilterString}`;
      }
      let matFilter = '';
      if (selectedmaterial.length > 0) {
        const matFilterString = selectedmaterial
          .map(mat => `filters[ProductionDetail][MaterialCode][$eq]=${mat}`)
          .join('&');
        matFilter = `&${matFilterString}`;
      }
      let buyerFilter = '';
      if (selectedBuyer.length > 0) {
        const buyerFilterString = selectedBuyer
          .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
          .join('&');
        buyerFilter = `&${buyerFilterString}`;
      }
      let searchFilter = '';
      if (selectedSearch.length > 0) {
        const SearchFilterString = selectedSearch
          .map(search => `filters[SearchKeyword][$eq]=${search}`)
          .join('&');
        searchFilter = `&${SearchFilterString}`;
      }
      let aliasFilter = '';
      if (selectedAlias.length > 0) {
        const aliasFilterString = selectedAlias
          .map(alias => `filters[ProductId][$eq]=${alias}`)
          .join('&');
        aliasFilter = `&${aliasFilterString}`;
      }
      let pronFilter = '';
      if (selectedpron.length > 0) {
        const pronFilterString = selectedpron
          .map(pron => `filters[ProductName][$eq]=${pron}`)
          .join('&');
        pronFilter = `&${pronFilterString}`;
      }
      let prodFilter = '';
      if (selectedpd.length > 0) {
        const prodFilterString = selectedpd
          .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
          .join('&');
        prodFilter = `&${prodFilterString}`;
      }
      let madeFilter = '';
      if (selectedmade.length > 0) {
        const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
        madeFilter = `&${madeFilterString}`;
      }
      let skuFilter = '';
      if (selectedsku.length > 0) {
        const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
        skuFilter = `&${skuFilterString}`;
      }
      let searchQryFilter = '';
      if (searchQuery.length > 0) {
        let searchQryy = searchQuery.trim();
        const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
        searchQryFilter = `&${searchQry}`;
        //  setCurrentPage(1)
      }

      const collectionResponse = await fetch(
        `${globalIP}/api/mstmaterialcollections?populate=*${collFilter}&filters[dis][$ne]=Discontinue`
      );
      const collectionJson = await collectionResponse.json();
      setCollectiondata(collectionJson.data);
      // Fetch product data for each MatCollectionCode
      const productDataPromises = collectionJson.data.map(async collection => {
        console.log(
          `${globalIP}/api/products?populate=*&filters[MaterialCollection][MatCollectionCode][$eq]=${collection.attributes.MatCollectionCode}`
        );
        const response = await fetch(
          `${globalIP}/api/products?populate=*&filters[MaterialCollection][MatCollectionCode][$eq]=${collection.attributes.MatCollectionCode}`
        );
        const json = await response.json();
        return { [collection.attributes.MatCollectionCode]: json.data };
      });
      const products = await Promise.all(productDataPromises);
      // Combine product data for all MatCollectionCodes into a single object
      const mergedProductData = Object.assign({}, ...products);
      setProductData(mergedProductData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setColLoading(false);
  };
  const handleCollChange = value => {
    setSelectedColl(value);
  };
  useEffect(() => {
    if (inView && limit && i !== 0) {
      setCurrentPage(prev => prev + 1);
      i++;
    }
  }, [inView]);
  ///// filters //////
  let i = 0;
  const [categorydata, setCategorydata] = useState([]);
  useEffect(() => {
    fetchDatac1();
  }, []);
  const fetchDatac1 = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode
        }));
        allData.push(...processedData);
      }
      setCategorydata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    fetchData5();
  }, []);
  const fetchData5 = async () => {
    if (isLoadingcolor) {
      return;
    }
    setIsLoadingcolor(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ColorName,
          value: item.attributes.ColorCode
        }));
        allData.push(...processedData);
      }
      setColordata(allData);
      setIsLoadingcolor(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchData2();
    }
  }, [selectedCategoryCode, selectedCategory]);
  const fetchData2 = async () => {
    if (isLoadingpro) {
      return;
    }
    setIsLoadingpro(true);
    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[Categorycode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    try {
      const productIdsQueryParam = selectedCategoryCode
        .map(id => `filters[Categorycode][$in][]=${id}`)
        .join('&');
      // Construct the API URL by appending the query parameters
      const apiUrl = `${globalIP}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=1${categoryFilter}`;

      const response = await fetch(apiUrl);
      const json = await response.json();

      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=${page}${categoryFilter}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode
        }));
        allData.push(...processedData);
      }
      setProductypedata(allData);
      setIsLoadingpro(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchDatabuyerN();
  }, []);
  const fetchDatabuyerN = async () => {
    if (isLoadingbu) {
      return;
    }
    setIsLoadingbu(true);
    try {
      const response = await fetch(`${globalIP}/api/buyer-details?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${globalIP}/api/buyer-details?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.buyernm,
          value: item.attributes.buyernm
        }));
        allData.push(...processedData);
      }
      setBuyerNamedata(allData);
      setIsLoadingbu(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchDataSearch();
  }, []);
  const fetchDataSearch = async () => {
    if (isLoadingse) {
      return;
    }
    setIsLoadingse(true);
    try {
      const response = await fetch(`${globalIP}/api/searchs-keyword`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

      json.forEach(item => {
        if (item.SearchKeyword && !uniqueKeywords.has(item.SearchKeyword)) {
          uniqueKeywords.add(item.SearchKeyword);
        }
      });

      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setSearchdata(processedData);
      setIsLoadingse(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchDatapron();
  }, []);
  const fetchDatapron = async () => {
    if (isLoadingpron) {
      return;
    }
    setIsLoadingpron(true);
    try {
      const response = await fetch(`${globalIP}/api/products-name`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

      json.forEach(item => {
        if (item.ProductName && !uniqueKeywords.has(item.ProductName)) {
          uniqueKeywords.add(item.ProductName);
        }
      });

      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setProdNamedata(processedData);
      setIsLoadingpron(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchDataprod();
  }, []);
  const fetchDataprod = async () => {
    if (isLoadingprod) {
      return;
    }
    setIsLoadingprod(true);
    try {
      const response = await fetch(`${globalIP}/api/products-designer`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.ProductDesigner && !uniqueKeywords.has(item.ProductDesigner)) {
          uniqueKeywords.add(item.ProductDesigner);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setProdDdata(processedData);
      setIsLoadingprod(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchDatamade();
  }, []);
  const fetchDatamade = async () => {
    if (isLoadingmade) {
      return;
    }
    setIsLoadingmade(true);
    try {
      const response = await fetch(`${globalIP}/api/mades-by`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.MadeBy && !uniqueKeywords.has(item.MadeBy)) {
          uniqueKeywords.add(item.MadeBy);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setMadedata(processedData);
      setIsLoadingmade(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [finishdata, setFinishdata] = React.useState([]);
  const [isLoadingfin, setIsLoadingfin] = React.useState(false);
  useEffect(() => {
    fetchData4();
  }, []);
  const fetchData4 = async () => {
    if (isLoadingfin) {
      return;
    }
    setIsLoadingfin(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.FinishName,
          value: item.attributes.FinishCode
        }));
        allData.push(...processedData);
      }
      setFinishdata(allData);
      setIsLoadingfin(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadinalias] = useState(false);
  useEffect(() => {
    fetchDataalias();
  }, []);
  const fetchDataalias = async () => {
    if (isLoadingalias) {
      return;
    }
    setIsLoadinalias(true);
    try {
      const response = await fetch(`${globalIP}/api/fetchs-aliascd`);
      const json = await response.json();
      const processedData = json
        .filter(item => item.ProductId !== null && item.ProductId !== undefined && item.ProductId !== "")
        .map(item => ({
          label: item.ProductId,
          value: item.ProductId
        }));
      setAliasdata(processedData);
      setIsLoadinalias(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadinsku] = useState(false);
  useEffect(() => {
    fetchDatasku();
  }, []);
  const fetchDatasku = async () => {
    if (isLoadingsku) {
      return;
    }
    setIsLoadinsku(true);
    try {
      const response = await fetch(`${globalIP}/api/buyers-sku`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.BuyerSku && !uniqueKeywords.has(item.BuyerSku)) {
          uniqueKeywords.add(item.BuyerSku);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setSkudata(processedData);
      setIsLoadinsku(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [materialdata, setMaterialdata] = React.useState([]);
  const [isLoadingmat, setIsLoadingmat] = React.useState(false);
  useEffect(() => {
    fetchData7();
  }, []);
  const fetchData7 = async () => {
    if (isLoadingmat) {
      return;
    }
    setIsLoadingmat(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstmaterials?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstmaterials?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.MaterialName,
          value: item.attributes.MaterialCode
        }));
        allData.push(...processedData);
      }
      setMaterialdata(allData);
      setIsLoadingmat(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchData6();
  }, []);
  const fetchData6 = async () => {
    if (isLoadinghsn) {
      return;
    }
    setIsLoadinghsn(true);
    try {
      const response = await fetch(
        `${globalIP}/api/msthscodes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/msthscodes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.hscode,
          value: item.attributes.hscode
        }));
        allData.push(...processedData);
      }
      setHsndata(allData);
      setIsLoadinghsn(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handleFilterChange = (
    filterType,
    value,
    prevValue,
    clearSearchQuery,
    setClearSearchQuery
  ) => {
    const tempsearchq = searchQuery;
    setSearchQuery(''); // Clear the search query first

    const anyOtherFilterSelected =
      selectedCategory.length > 0 ||
      selectedProductType.length > 0 ||
      selectedColor.length > 0 ||
      selectedFinish.length > 0 ||
      selectedhsn.length > 0 ||
      selectedmaterial.length > 0 ||
      selectedBuyer.length > 0 ||
      selectedSearch.length > 0 ||
      selectedAlias.length > 0 ||
      selectedpron.length > 0 ||
      selectedpd.length > 0 ||
      selectedmade.length > 0 ||
      selectedsku.length > 0;

    // Handle setting clearSearchQuery flag
    if (anyOtherFilterSelected || prevValue.length === 0) {
      setClearSearchQuery(true);
    } else {
      setClearSearchQuery(false);
      setSearchQuery(tempsearchq);
    }

    // Set the filter state for the specific filter type
    switch (filterType) {
      case 'category':
        setSelectedCategory(value);
        break;
      case 'productType':
        setSelectedProductType(value);
        break;
      case 'color':
        setSelectedColor(value);
        break;
      case 'finish':
        setSelectedFinish(value);
        break;
      case 'hsn':
        setSelectedhsn(value);
        break;
      case 'material':
        setSelectedmaterial(value);
        break;
      case 'buyer':
        setSelectedBuyer(value);
        break;
      case 'search':
        setSelectedSearch(value);
        break;
      case 'alias':
        setSelectedAlias(value);
        break;
      case 'productName':
        setSelectedPron(value);
        break;
      case 'productDescription':
        setSelectedProd(value);
        break;
      case 'made':
        setSelectedMade(value);
        break;
      case 'sku':
        setSelectedSku(value);
        break;
      default:
        break;
    }

    // Reset pagination
    //  setPage(1);
    setCurrentPage(1);

    // Refetch data only after search query is cleared
    //  setReload((prev) => !prev);
  };
  // Update individual handlers
  const handleCategoryChange = value => {
    handleFilterChange('category', value, selectedCategory, clearSearchQuery, setClearSearchQuery);
  };
  const handleProductTypeChange = value => {
    handleFilterChange(
      'productType',
      value,
      selectedProductType,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleColorChange = value => {
    handleFilterChange('color', value, selectedColor, clearSearchQuery, setClearSearchQuery);
  };
  const handleFinishChange = value => {
    handleFilterChange('finish', value, selectedFinish, clearSearchQuery, setClearSearchQuery);
  };
  const handleHSNChange = value => {
    handleFilterChange('hsn', value, selectedhsn, clearSearchQuery, setClearSearchQuery);
  };
  const handleMaterialChange = value => {
    handleFilterChange('material', value, selectedmaterial, clearSearchQuery, setClearSearchQuery);
  };
  const handleBuyerChange = value => {
    handleFilterChange('buyer', value, selectedBuyer, clearSearchQuery, setClearSearchQuery);
  };
  const handleSearchChange = value => {
    handleFilterChange('search', value, selectedSearch, clearSearchQuery, setClearSearchQuery);
  };
  const handleAliasChange = value => {
    handleFilterChange('alias', value, selectedAlias, clearSearchQuery, setClearSearchQuery);
  };
  const handleProNameChange = value => {
    handleFilterChange('productName', value, selectedpron, clearSearchQuery, setClearSearchQuery);
  };
  const handleProDChange = value => {
    handleFilterChange(
      'productDescription',
      value,
      selectedpd,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleMadeChange = value => {
    handleFilterChange('made', value, selectedmade, clearSearchQuery, setClearSearchQuery);
  };
  const handleSkuChange = value => {
    handleFilterChange('sku', value, selectedsku, clearSearchQuery, setClearSearchQuery);
  };

  const [showDrawer, setShowDrawer] = useState(false);
  ///// filters///////

  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchDataHeads();
  }, []);
  const fetchDataHeads = async () => {
    try {
      const response = await fetch(`${globalIP}/api/mstfilters?populate=*`);
      const json = await response.json();
      const filteredData = json.data.map(item => ({
        FilterName: item.attributes.FilterName,
        filterstatus: item.attributes.filterstatus
      }));
      setHead(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [openMenuBar, setOpenMenuBar] = useState(false);

  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const [data11, setData11] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState('inch');
  const [modeldata, setmodeldata] = useState([]);
  const [id, setId] = useState();
  const handleOpen = (value, prdcd) => {
    setSize(value);
    setOpen(true);
    setId(prdcd);
    const newArray = [...data123];
    const filteredData = newArray.filter(item => item.id === prdcd);
    setmodeldata(filteredData);
    console.log('filteredData-----', filteredData);
    if (filteredData[0].attributes.SetStatus === 'Set') {
      setData11(filteredData[0].attributes.SetSizes);
    } else {
      const data = [
        {
          Length: filteredData[0].attributes.Length,
          Width: filteredData[0].attributes.Width,
          Height: filteredData[0].attributes.Height,
          SizeUnit: filteredData[0].attributes.SizeUnit
        }
      ];
      setData11(data);
    }
  };
  const unitOptions = [
    { label: 'Inch', value: 'inch' },
    { label: 'CM', value: 'cm' }
  ];
  // const handleSizeChange = value => {
  //   // setSizeUnit(newSizeUnit);
  //   setSelectedUnit(value);
  //   const convertedData = convertDimensions(data11, value);
  //   console.log('Converted data :', convertedData);
  //   setData11(convertedData);
  // };
  // const convertDimensions = (data, selectedUnit) => {
  //   const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

  //   return data.map(item => {
  //     let convertedItem = {
  //       ...item,
  //       Length: (item.Length || 0) * conversionFactor,
  //       Width: (item.Width || 0) * conversionFactor,
  //       Height: (item.Height || 0) * conversionFactor,
  //       SizeUnit: selectedUnit
  //     };

  //     // If the selected unit is cm, round to one decimal place
  //     if (selectedUnit === 'cm') {
  //       convertedItem.Length = parseFloat(convertedItem.Length.toFixed(1));
  //       convertedItem.Width = parseFloat(convertedItem.Width.toFixed(1));
  //       convertedItem.Height = parseFloat(convertedItem.Height.toFixed(1));
  //     }

  //     // If the selected unit is inch, round to the nearest whole number
  //     if (selectedUnit === 'inch') {
  //       convertedItem.Length = Math.round(convertedItem.Length);
  //       convertedItem.Width = Math.round(convertedItem.Width);
  //       convertedItem.Height = Math.round(convertedItem.Height);
  //     }
  //     console.log('Converted data :', convertedItem);
  //     return convertedItem;
  //   });
  // };
  const handleSizeChange = value => {
    setSelectedUnit(value);
    const convertedData = convertDimensions(data11, value);
    setData11(convertedData);
  };
  const convertDimensions = (data, selectedUnit) => {
    const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

    return data.map(item => {
      // Skip conversion if the SizeUnit matches the selectedUnit
      if (item.SizeUnit === selectedUnit) {
        console.log('Unchanged data:', item);
        return item;
      }

      // Convert dimensions if SizeUnit does not match the selectedUnit
      let convertedItem = {
        ...item,
        Length: (item.Length || 0) * conversionFactor,
        Width: (item.Width || 0) * conversionFactor,
        Height: (item.Height || 0) * conversionFactor,
        SizeUnit: selectedUnit
      };

      console.log('Converted data:', convertedItem);
      return convertedItem;
    });
  };
  const handleClose = () => setOpen(false);
  const [finShow, setFinShow] = useState(false);
  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
      setFinShow(json.data[0].attributes.setFinish);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const [imageList, setImageList] = useState([]);
  useEffect(() => {
    if (id) {
      fetchData1234();
    }
  }, [id]);
  const fetchData1234 = async () => {
    const response = await fetch(`${globalIP}/api/products?populate=*&filters[id][$eq]=${id}`);
    const json = await response.json();
    // Concatenate data from all pages into a single array
    const extractedImageList = json.data
      .filter(item => item.attributes.MultipleImage && item.attributes.MultipleImage.data)
      .map(item => item.attributes.MultipleImage.data.map(image => image.attributes.url))
      .flat(); // Flatten the array of arrays
    const coverImage = json.data.map(item => item.attributes.CoverImage.data.attributes.url);
    extractedImageList.unshift(coverImage);
    const prefixed_list = extractedImageList.map(file => globalIP + file);
    setImageList(prefixed_list);
  };

  const defaultImageIndex = 0; // Index of the default image
  const [selectedImageIndex, setSelectedImageIndex] = useState(defaultImageIndex);

  const handleNextImage = item => {
    const totalImages = item?.attributes?.MultipleImage?.data?.length + 1; // Add 1 for the CoverImage
    setSelectedImageIndex(prevIndex => (prevIndex + 1) % totalImages);
  };

  const handlePrevImage = item => {
    const totalImages = item?.attributes?.MultipleImage?.data?.length + 1; // Add 1 for the CoverImage
    setSelectedImageIndex(prevIndex => (prevIndex - 1 + totalImages) % totalImages);
  };

  useEffect(() => {
    const item = modeldata[0]; // Assuming you want the first item in the array

    if (!item) {
      console.error('Item is undefined');
      return;
    }

    if (selectedImageIndex === 0) {
      console.log('imgindex : ' + selectedImageIndex);
      // When selected index is 0, set the CoverImage
      const coverImageUrl = item?.attributes?.CoverImage?.data?.attributes?.url;
      if (coverImageUrl) {
        setSelectedImagePath({
          url: coverImageUrl,
          id: item.id,
          default: true
        });
      } else {
        console.error('Cover image not found');
      }
    } else {
      console.log('imgindex11 : ' + selectedImageIndex);
      // Otherwise, set the corresponding MultipleImage
      const imageIndex = selectedImageIndex - 1; // Subtract 1 because CoverImage is index 0
      const selectedImage = item?.attributes?.MultipleImage?.data?.[imageIndex];
      if (selectedImage && selectedImage?.attributes?.url) {
        setSelectedImagePath({
          url: selectedImage?.attributes?.url,
          id: item.id,
          default: true
        });
      } else {
        console.error('Multiple image not found at index', imageIndex);
      }
    }
  }, [selectedImageIndex, modeldata]);

  const [vardata, setVarData] = useState([]);
  const fetchDataVData = async id => {
    try {
      const response = await fetch(
        `${globalIP}/api/variant-products?filters[Variant_Id][$eq]=${id}&populate=*`
      );
      const json = await response.json();
      setVarData(json.data);
      return json.data;
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [varOpen, setVarOpen] = useState(false);
  const openVardata = id => {
    setVarOpen(true);
    fetchDataVData(id);
  };
  const selectallvar = async id => {
    const data = await fetchDataVData(id);
    if (data) {
      // Merge the new IDs with the existing selected items
      setSelectedItems(prevSelectedItems => {
        const newIds = data.map(row => row.id);
        // Create a Set to ensure uniqueness
        const mergedIds = new Set([...prevSelectedItems, ...newIds]);
        // Convert the Set back to an array
        return Array.from(mergedIds);
      });
    }
  };
  const handleCheckAllT = (value, checked) => {
    if (checked) {
      setSelectedItems(prevState => [
        ...prevState,
        ...vardata.map(row => row.id).filter(id => !prevState.includes(id)) // Only add if not already in prevState
      ]);
    } else {
      setSelectedItems(prevState =>
        prevState.filter(item => !vardata.some(row => row.id === item))
      );
    }
  };
  const history = useNavigate();
  const handleEditAllRowCategory = rowData => {
    history(`/${ugr}/products-create?svid=${rowData.id}`);
  };
  const [activeKey, setActiveKey] = useState('content1');
  const handleNavSelect = eventKey => {
    setActiveKey(eventKey);
  };
  // useFilter(
  //   selectedCategory,
  //   selectedProductType,
  //   selectedColor,
  //   selectedFinish,
  //   selectedAlias,
  //   setAliasdata,
  //   setFinishdata,
  //   setColordata,
  //   setCategorydata,
  //   setProductypedata
  // );
  const items = [
    { key: "content1", label: "Manage Collection" },
    { key: "content2", label: "Library" },
  ];
  return (
    <>
      <LoadingBar
        color="#3498ff"
      // progress={progress}
      // onLoaderFinished={() => setProgress(0)}
      />

      {activeKey === 'content1' && (
        <>
          <Library activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} />
        </>
      )}
      {activeKey === 'content2' && (
        <>
          <div
            style={{
              justifyContent: 'space-between',
              width: '-webkit-fill-available',
              position: 'fixed',
              height: '175px',
              background: '#fff',
              zIndex: 1
            }}
          >
            <Stack
              className="table-toolbar collection-head"
              justifyContent="space-between"
              style={{ marginTop: '10px' }}
            >
              <Stack direction="column" alignItems="flex-start">
                <Stack direction="column" alignItems="flex-start">
                  <Stack direction="row" alignItems="flex-start" spacing={132} className="mng-coll">
                    {/* <NavD activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} /> */}
                    {/* <h3 className="title">Manage Collection</h3> */}
                    {!showPanel ? (
                      <div onClick={() => setOpenMenuBar(!openMenuBar)}>
                        <MenuIcon className="burgerMenu1" />
                      </div>
                    ) : (
                      <></>
                    )}
                  </Stack>
                  <Breadcrumb>
                    <Breadcrumb.Item>
                      <Link to={`/${ugr}/dashboard`}>Home</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Library</Breadcrumb.Item>
                  </Breadcrumb>
                </Stack>
                {showPanel ? (
                  <>
                    <div id="custom-container" style={{ position: 'relative' }}>
                      <CheckPicker
                        className='me-1'
                        data={collectionfdata}
                        style={{ width: 150 }}
                        value={selectedColl}
                        onChange={handleCollChange}
                        placeholder="Select Collection"
                        container={() => document.getElementById('custom-container')}
                      />
                      <Dropdown
                        menu={{
                          items,
                          onClick: ({ key }) => handleNavSelect(key),
                        }}
                        trigger={["click"]}
                      >
                        <Button>
                          View <EyeFilled />
                        </Button>
                      </Dropdown>
                    </div>
                  </>
                ) : (
                  <>
                    <Stack
                      style={{ position: 'relative', marginBottom: '14px' }}
                      spacing={5}
                      className={openMenuBar ? 'product-item' : 'mange-search'}
                    >
                      <HeaderFilter
                        {...{
                          head,
                          label,
                          //data states
                          categorydata,
                          productypedata,
                          colordata,
                          proNamedata,
                          skudata,
                          buyernamedata,
                          finishdata,
                          aliasdata,
                          searchdata,
                          proDdata,
                          madedata,
                          hsndata,
                          // materialdata,
                          setCategorydata,
                          // setIsLoadingc,
                          // isLoadingc,
                          // SetIsLoadingTableData,
                          // setProgress,
                          setColordata,
                          isLoadingcolor,
                          setIsLoadingcolor,
                          // setFinishdata,
                          isLoadingfin,
                          setIsLoadingfin,
                          setHsndata,
                          isLoadinghsn,
                          setIsLoadinghsn,
                          //selectedstates
                          selectedCategory,
                          selectedProductType,
                          selectedColor,
                          selectedpron,
                          selectedsku,
                          selectedBuyer,
                          selectedFinish,
                          selectedAlias,
                          selectedSearch,
                          selectedpd,
                          selectedmade,
                          selectedhsn,
                          selectedmaterial,

                          selectedDateRange,
                          selectedUpdatedDateRange,
                          handleDatechange,
                          handleUpdatedDatechange,
                          handleCategoryChange,
                          handleProductTypeChange,
                          handleColorChange,
                          handleProNameChange,
                          handleSkuChange,
                          handleBuyerChange,
                          handleFinishChange,
                          handleAliasChange,
                          handleSearchChange,
                          handleProDChange,
                          handleMadeChange,
                          handleHSNChange,
                          handleMaterialChange,
                          //onopenfunctions
                          // fetchCategory,
                          // fetchColors,
                          // fetchFinishes,
                          // fetchProductTypes,
                          // fetchAlias
                          //rendermenus
                          // renderMenu2,
                          // renderMenu5,
                          // renderMenu1,
                          // renderMenu,
                          // renderMenu3,
                          // renderMenu4
                        }}
                      />
                      <Button appearance="default" className='me-1' active onClick={() => setShowDrawer(true)}>
                        More Filter
                      </Button>
                      <Dropdown
                        menu={{
                          items,
                          onClick: ({ key }) => handleNavSelect(key),
                        }}
                        trigger={["click"]}
                      >
                        <Button>
                          View <EyeFilled />
                        </Button>
                      </Dropdown>
                    </Stack>
                  </>
                )}
              </Stack>
              {showSearch && (
                <Stack
                  alignItems="flex-end"
                  spacing={14}
                  // style={{ marginBottom: '-40px' }}
                  className="mange-search quotation-srchbar "
                >
                  <Stack direction="row" spacing={5} className="create-q">
                    <InputGroup inside>
                      {/* <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={handleSearch}
                  /> */}
                      <Input
                        placeholder="Search"
                        type="text"
                        value={searchQuery}
                        onChange={value => {
                          setSearchQuery(value);
                        }}
                      // onKeyDown={event => {
                      //   if (event.key === 'Enter') {
                      //     setSearchQryBtn = true
                      //     searchQry();
                      //   }
                      // }}
                      />
                      <InputGroup.Addon>
                        <SearchIcon
                          onClick={() => {
                            // setSearchQryBtn = true
                            // searchQry();
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </InputGroup.Addon>
                    </InputGroup>
                  </Stack>

                  <Stack spacing={10} className="quotation-search  q-search2">
                    <Checkbox
                      indeterminate={
                        selectedItems.length > 0 && selectedItems.length < data123.length
                      }
                      checked={
                        selectedItems.length ===
                        (filtersApplied ? applyFilters().length : data123.length)
                      }
                      onChange={handleCheckAll}
                    >
                      Select all
                    </Checkbox>
                  </Stack>
                </Stack>
              )}
            </Stack>
            <Divider style={{ margin: '0px' }} />
          </div>
          <div className="row" style={{ marginTop: '168px' }}>
            <Panel>
              {showPanel ? (
                <>
                  {colLoading ? (
                    <Loader speed="fast" center content="loading..." vertical />
                  ) : (
                    <FlexboxGrid
                      justify="start"
                      style={{ marginTop: '10px' }}
                      className="datatbl-img"
                    >
                      {collectiondata.map(item => (
                        <FlexboxGrid.Item
                          as={Col}
                          colspan={24}
                          md={6}
                          className="data-tbl-img"
                          key={item.id}
                        >
                          <Panel bordered style={{ marginTop: '5px', borderRadius: '0' }}>
                            <h2 style={{ fontSize: '21px', fontFamily: 'raleway' }}>
                              {item.attributes.MatCollectionName}
                            </h2>
                            <Stack spacing={5} justifyContent="center">
                              <FlexboxGrid justify="space-between">
                                {productData[item.attributes.MatCollectionCode] &&
                                  productData[item.attributes.MatCollectionCode]
                                    .slice(0, 4)
                                    .map(product => (
                                      <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                                        <div
                                          key={product.id}
                                          style={{ textAlign: 'center' }}
                                          className="image-containerm"
                                        >
                                          <img
                                            src={`${globalIP}${product.attributes?.CoverImage?.data?.attributes?.url}`}
                                            alt="Protected"
                                            className="image-style"
                                          />
                                          <p
                                            style={{
                                              fontSize: '12px',
                                              fontFamily: 'raleway',
                                              marginBottom: '5px'
                                            }}
                                          >
                                            {product.attributes.ProductName}
                                          </p>
                                        </div>
                                      </FlexboxGrid.Item>
                                    ))}
                              </FlexboxGrid>
                            </Stack>
                            <p
                              style={{
                                fontSize: '15px',
                                color: '#007185',
                                fontFamily: 'sans-serif serif',
                                cursor: 'pointer',
                                float: 'right'
                              }}
                              onClick={() => handlePanelToggle(item.attributes.MatCollectionCode)}
                            >
                              See all
                            </p>
                          </Panel>
                        </FlexboxGrid.Item>
                      ))}
                    </FlexboxGrid>
                  )}
                </>
              ) : (
                <>
                  <Panel>
                    {(selectedCategory.length > 0 ||
                      selectedProductType.length > 0 ||
                      selectedColor.length > 0 ||
                      selectedFinish.length > 0 ||
                      selectedhsn.length > 0 ||
                      selectedmaterial.length > 0 ||
                      selectedBuyer.length > 0 ||
                      selectedSearch.length > 0 ||
                      selectedAlias.length > 0 ||
                      selectedpron.length > 0 ||
                      selectedpd.length > 0 ||
                      selectedmade.length > 0 ||
                      // searchQryBtn ||
                      selectedsku.length > 0) && (
                        <b style={{ marginLeft: '6px' }}>
                          Total Products: {data123.length}/{meta123.pagination.total}
                        </b>
                      )}

                    {/* {searchQuery && (
                    <b style={{ marginLeft: '6px' }}>Found Products: {foundProductCount}</b>
                  )} */}

                    {selectedCategory.length === 0 &&
                      selectedProductType.length === 0 &&
                      selectedColor.length === 0 &&
                      selectedFinish.length === 0 &&
                      selectedhsn.length === 0 &&
                      selectedmaterial.length === 0 &&
                      selectedBuyer.length === 0 &&
                      selectedSearch.length === 0 &&
                      selectedAlias.length === 0 &&
                      selectedpron.length === 0 &&
                      selectedpd.length === 0 &&
                      selectedmade.length === 0 &&
                      selectedsku.length === 0 &&
                      meta123 && (
                        <b style={{ marginLeft: '6px' }}>
                          Products: {data123.length}/{meta123.pagination.total}
                        </b>
                      )}
                    <FlexboxGrid
                      justify="start"
                      style={{ textAlign: 'center', marginTop: '10px' }}
                      className="datatbl-img"
                    >
                      {data123.map(item => (
                        <FlexboxGrid.Item as={Col} colspan={24} md={6} className="data-tbl-img">
                          <div className="col-md-12">
                            <Panel
                              className="box"
                              bordered
                              bodyFill
                              style={{ display: 'inline-block', width: '100%', height: '296px' }}
                            // onContextMenu={handleContextMenu}
                            >
                              <Stack justifyContent="space-between">
                                <Checkbox
                                  value={item.id} // Replace "id" with your unique identifier property
                                  checked={selectedItems.includes(item.id)}
                                  onChange={(value, checked) =>
                                    handleCheckboxChange(value, checked)
                                  }
                                />
                                {item.attributes.Variant === true ? (
                                  <ButtonGroup>
                                    <IconButton
                                      icon={<CheckIcon />}
                                      appearance="default"
                                      onClick={() => selectallvar(item.attributes.ProductCode)}
                                      active
                                    />
                                    <Button
                                      onClick={() => openVardata(item.attributes.ProductCode)}
                                      appearance="ghost"
                                      color="cyan"
                                    >
                                      Variant
                                    </Button>
                                  </ButtonGroup>
                                ) : (
                                  <></>
                                )}
                              </Stack>

                              <div
                                style={{ cursor: 'pointer' }} // Change cursor to indicate clickable
                                onClick={() =>
                                  handleCheckboxChange(item.id, !selectedItems.includes(item.id))
                                }
                              >
                                <img
                                  src={`${globalIP}${item.attributes?.CoverImage?.data?.attributes?.url}`}
                                  className="imgp watermarked-image"
                                  loading="lazy"
                                  alt="Protected"
                                  style={{ margin: "auto" }}
                                />
                              </div>
                              <div className="overlay" onClick={() => handleOpen('lg', item.id)}>
                                Quick View
                              </div>
                              <Panel>
                                <b>Product : {item.attributes.ProductName} </b>
                                <p>
                                  {label[0]?.attributes.AliasCode} : {item.attributes.ProductId}
                                </p>
                              </Panel>
                            </Panel>
                          </div>
                        </FlexboxGrid.Item>
                      ))}
                    </FlexboxGrid>
                  </Panel>
                  <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
                </>
              )}
              {selectedItems.length > 0 && (
                <Notification
                  type="success"
                  onClose={handleCartClose}
                  style={{
                    position: 'fixed',
                    top: '80%',
                    right: 20,
                    transform: 'translateY(-50%)',
                    zIndex: 9999,
                    background: 'rgb(34 171 189)',
                    color: 'white',
                    width: '20%'
                  }}
                >
                  <b style={{ color: 'white' }}>Selected Products : {selectedItems.length}</b>
                  <Divider vertical />
                  <Link
                    to={{
                      pathname: `/${ugr}/editDetailsC`,
                      search: `?selectedItems=${selectedItems.join(',')}`
                    }}
                  >
                    <Button
                      style={{ float: 'right', marginTop: '-7px' }}
                      appearance="subtle"
                      active
                    >
                      <b>Next</b>
                    </Button>
                  </Link>
                </Notification>
              )}
            </Panel>
          </div>
        </>
      )}
      <FilterDrawer
        {...{
          showDrawer,
          setShowDrawer,
          head,
          label,
          //data states
          categorydata,
          productypedata,
          colordata,
          proNamedata,
          skudata,
          buyernamedata,
          finishdata,
          aliasdata,
          searchdata,
          proDdata,
          madedata,
          hsndata,
          // materialdata,
          setCategorydata,
          // setIsLoadingc,
          // isLoadingc,
          // SetIsLoadingTableData,
          // setProgress,
          setColordata,
          isLoadingcolor,
          setIsLoadingcolor,
          setFinishdata,
          isLoadingfin,
          setIsLoadingfin,
          setHsndata,
          isLoadinghsn,
          setIsLoadinghsn,
          // setMaterialdata,
          // isLoadingmat,
          // setIsLoadingmat,
          //selectedstates
          selectedCategory,
          selectedProductType,
          selectedColor,
          selectedpron,
          selectedsku,
          selectedBuyer,
          selectedFinish,
          selectedAlias,
          selectedSearch,
          selectedpd,
          selectedmade,
          selectedhsn,
          selectedmaterial,

          selectedDateRange,
          selectedUpdatedDateRange,
          handleDatechange,
          handleUpdatedDatechange,
          handleCategoryChange,
          handleProductTypeChange,
          handleColorChange,
          handleProNameChange,
          handleSkuChange,
          handleBuyerChange,
          handleFinishChange,
          handleAliasChange,
          handleSearchChange,
          handleProDChange,
          handleMadeChange,
          handleHSNChange,
          handleMaterialChange,
          //onopenfunctions
          // fetchCategory,
          // fetchColors,
          // fetchFinishes,
          // fetchProductTypes,
          // fetchAlias,
          // fetchHsn,
          // fetchMaterials
          //rendermenus
          // renderMenu2,
          // renderMenu5,
          // renderMenu1,
          // renderMenu,
          // renderMenu3,
          // renderMenu4
        }}
      />
      <ProductQuickView
        {...{
          data11,
          label,
          handleClose,
          open,
          size,
          modeldata,
          handlePrevImage,
          handleNextImage,
          selectedImagePath,
          setSelectedImagePath,
          sizeshow,
          unitOptions,
          selectedUnit,
          handleSizeChange,
          convertDimensions,
          finShow,
          attributesName
        }}
      />
      <Modal open={varOpen} onClose={() => setVarOpen(false)} size="lg" backdrop="static">
        <Modal.Header>
          <Modal.Title>
            <b>Variants</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table height={250} data={vardata} bordered cellBordered>
            <Column width={50} align="center">
              <HeaderCell style={{ padding: 0 }}>
                <div style={{ lineHeight: '40px' }}>
                  <Checkbox
                    inline
                    // checked={selectedItems.length === vardata.length}
                    checked={vardata.every(item => selectedItems.includes(item.id))}
                    indeterminate={vardata.some(item => selectedItems.includes(item.id))}
                    // indeterminate={
                    //   selectedItems.length > 0 && selectedItems.length < vardata.length
                    // }
                    onChange={handleCheckAllT}
                  />
                </div>
              </HeaderCell>
              <CheckCell
                dataKey="id"
                checkedKeys={selectedItems}
                onChange={(rowId, checked) => handleCheckboxChange(rowId, checked)}
                rowData={undefined}
              />
            </Column>
            <Column width={100} align="center">
              <HeaderCell>
                <b>Image</b>
              </HeaderCell>
              <Table.Cell>
                {rowData => {
                  // Define a function to show the enlarged image on hover
                  const renderTooltip = imageSrc => (
                    <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                      <img
                        src={imageSrc}
                        alt="Product Image"
                        style={{ width: 400, height: 'auto', objectFit: 'cover' }}
                      />
                    </Tooltip>
                  );
                  return (
                    <Whisper
                      trigger="hover"
                      placement="right"
                      speaker={renderTooltip(
                        `${ipp}${rowData.attributes.CoverImage.data.attributes.url}`
                      )}
                    >
                      <img
                        src={`${ipp}${rowData.attributes.CoverImage.data.attributes.url}`}
                        alt="Product Image"
                        style={{ width: 50, height: 50, marginTop: '-16px', objectFit: 'cover' }}
                      />
                    </Whisper>
                  );
                }}
              </Table.Cell>
            </Column>
            <Column width={100} align="center">
              <HeaderCell>
                <b>Alias Code</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ProductId'} />
            </Column>
            <Column flexGrow={1} align="center" fullText>
              <HeaderCell>
                <b>Description</b>
              </HeaderCell>
              <Cell dataKey={'attributes.Description'} />
            </Column>
            <Column width={200} align="center">
              <HeaderCell>
                <b>Product Name</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ProductName'} />
            </Column>
            <Column width={100} align="center">
              <HeaderCell>Finish</HeaderCell>
              <Cell dataKey={'attributes.FinishName'} />
            </Column>
            <Column width={80} align="center">
              <HeaderCell>Color</HeaderCell>
              <Cell dataKey={'attributes.ColorName'} />
            </Column>
            <Column width={80} align="center">
              <HeaderCell>Action</HeaderCell>
              <Cell>
                {rowData => (
                  <>
                    <Whisper speaker={<Tooltip>Update</Tooltip>}>
                      <IconButton
                        icon={<EditIcon />}
                        onClick={() => handleEditAllRowCategory(rowData)}
                        active
                        size="sm"
                      />
                    </Whisper>
                  </>
                )}
              </Cell>
            </Column>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setVarOpen(false)} appearance="primary" color="cyan">
            Confirm Selection
          </Button>
        </Modal.Footer>
      </Modal>
      <Stack
        justifyContent="flex-end"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          paddingRight: '16px'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          {' '}
          <a href="https://erpdaddy.com/" target="_blank">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
    </>
  );
};

export default ManageCollection;
